import { type FC } from "react";

import { ProductBatchUpdateButton } from "src/app/features/Product/components/buttons/ProductBatchUpdateButton";
import { ProductFormCopyButton } from "src/app/features/Product/components/buttons/ProductFormCopyButton";
import { ProductSearchForm } from "src/app/features/Product/components/forms/ProductSearchForm";
import { ProductsTable } from "src/app/features/Product/components/tables/ProductsTable";
import type { ProductEntity } from "src/app/features/Product/types/ProductEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { Permissions } from "../../../../core/router/config/Permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const ProductsPage: FC<NoneOwnProps> = () => {
    const table = <ProductsTable />;
    const searchForm = <ProductSearchForm />;
    const hasAccess = canAccess(ResourceName.PRODUCTS, "canRead");

    return (
        <PageLayout name="Products_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.products" />
                    <ResourceManager<ProductEntity>
                        useDataGroup
                        dataMapperKey="productsTableData"
                        resource={ResourceName.PRODUCTS}
                        table={table}
                        searchForm={searchForm}
                        customActions={[
                            {
                                action: <ProductFormCopyButton />,
                                permission: Permissions.COPY,
                            },
                            {
                                action: <ProductBatchUpdateButton />,
                                permission: "batchUpdate",
                            },
                        ]}
                        actions={[Actions.ADD, Actions.DELETE, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
